import { createSlice } from "@reduxjs/toolkit";

export const locationToastIdSlice = createSlice({
  name: "toast",
  initialState: {
    toastIds: {}
  },
  reducers: {
    addToastId: (state, action) => {
      const { locationId, toastId } = action.payload;
      state.toastIds[locationId] = toastId;
    },
    removeToastId: (state, action) => {
      const locationId = action.payload;
      delete state.toastIds[locationId];
    }
  }
});

export const { addToastId, removeToastId } = locationToastIdSlice.actions;

export default locationToastIdSlice.reducer;
